import { createContext, useContext } from "react";
export const ClientCallbackContext = createContext({});
export const useClientCallback = () => useContext(ClientCallbackContext);
